// extracted by css-extract-rspack-plugin
export default {"container":"ImageBlank_container___Cx1c","bgGray":"ImageBlank_bgGray__dAJXN","bgWhite":"ImageBlank_bgWhite__a_dLR"};